import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";

export default () => {
    const { response: { products } } = useAppState();
    const masterSet = new Set([])
    const [ swatchData, setSwatchData ] = useState([]);

    useEffect(() => {  
        if(!products?.hits || products.hits?.length < 1) return;

        var tagsToFetch;

        products?.hits?.map((product) =>{
            var masterTag = product.tags1?.filter(name => name.includes("master"))?.toString();
            masterSet.add(masterTag);
            let masterArray = Array.from(masterSet);
            tagsToFetch = masterArray;
        });

        

        const fetchRelatedProducts = async (master) => {
            let query = `
                query {
                    products(limit: 250, filter: {availability: "InStock", tags1: ${JSON.stringify(master)}}) {
                        products{
                            productId
                            name
                            inventoryLevel
                            tags1
                            availability
                            imageUrl
                            alternateImageUrls
                        }
                    }
                }`;
            const response = await fetch('https://api.nosto.com/v1/graphql', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/graphql',
                    'Authorization': 'Basic ' + btoa(":" + "5T016m99S9TktCX9PDubcZU3YVYu3ZObRMtyLLCRV1qhXA2vnyMCzg4IY509NBdB")
                }),
                mode: 'cors',
                body: query
            })

            if (response?.status === 200){
                const data = await response.json()
                const fetchedResults = data?.data?.products?.products || []
                return fetchedResults;
            }
        }

        if(masterSet?.length < 1) return

        fetchRelatedProducts(tagsToFetch).then(data => {
            //const filteredData = data.filter(product => !product.name.includes("Long Torso") && !product.name.includes("Cheeky") && !product.name.includes("Full Coverage"))
            setSwatchData(data);
        })

    }, [ products ])

    return { swatchData }

}